import {useState} from "react";

import {useAppSelector} from "@redux/store";
import {Button} from "@/components";
import arrowRight from "@/assets/icons/arrowIndicRight.svg";

import {NewsItem} from "../../components/NewsItem/NewsItems";
import {NewsSkeleton} from "../../components/NewsSkeleton/NewsSkeleton";
import styles from "./News.module.scss"

const limit = 5;

export const News = () => {
	const { news, isLoading } = useAppSelector((state) => state.news);
	
	const [newsCount, setNewsCount] = useState(limit);

	const newsToShow = news.slice(0, newsCount);
	
	const handleMoreClick = () => {
		setNewsCount(newsCount + limit);
	};

	return (
		<div className={styles.wrapper}>
			{
				isLoading ? (
					<NewsSkeleton />
				) : (
					<>
						<div className={styles.newsContainer}>
							{newsToShow.length > 0 && newsToShow.map((item) => (
								<NewsItem item={item} key={item.id} />
							))}
						</div>
						{
							newsCount < news.length ? (
								<div className={styles.buttonContainer}>
									<Button newStyles={styles.button} onClickFunc={handleMoreClick}>
										Загрузить еще
										<img className={styles.arrow} src={arrowRight} />
									</Button>
								</div>
							) : null
						}
					</>
				)
			}
		</div>
	)
}